// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MediaItem_wrapper__b8ct3","item":"MediaItem_item__2Q-hC","checkbox":"MediaItem_checkbox__23u5T","checkboxVisible":"MediaItem_checkboxVisible__3iWEZ"};